const DOCS_BASE = import.meta.env.DEV ? 'http://localhost:12082' : 'https://docs.skjv.ai';

interface DocSection {
  label: string;
  items: { label: string; slug: string }[];
}

const sections: DocSection[] = [
  {
    label: 'User Guide',
    items: [
      { label: 'Getting Started', slug: 'getting-started/introduction' },
      { label: 'Bible Reader', slug: 'users/bible-reader' },
      { label: "Strong's Concordance", slug: 'users/strongs-lookup' },
      { label: 'Studies', slug: 'users/study-guide' },
      { label: 'Bookmarks & Notes', slug: 'users/bookmarks-notes' },
      { label: 'AI Chat', slug: 'users/chat' },
    ],
  },
];

/**
 * Docs tab content - table of contents linking to docs.skjv.ai.
 */
export function DocsContent() {
  return (
    <div className="space-y-5">
      <p className="text-xs text-stone-500 dark:text-stone-400">
        Full documentation at{' '}
        <a
          href={DOCS_BASE}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline"
        >
          {import.meta.env.DEV ? 'localhost:12082' : 'docs.skjv.ai'}
        </a>
      </p>

      {sections.map((section) => (
        <section key={section.label}>
          <h2 className="mb-2 text-sm font-semibold text-stone-800 dark:text-stone-200">
            {section.label}
          </h2>
          <ul className="space-y-1">
            {section.items.map((item) => (
              <li key={item.slug}>
                <a
                  href={`${DOCS_BASE}/${item.slug}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block rounded-lg px-3 py-2 text-sm text-stone-600 transition-colors hover:bg-stone-100/50 dark:text-stone-400 dark:hover:bg-stone-800/30"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
